module.exports = __webpack_public_path__ + "media/images/icons/youtube-461ac6b574894ab1b4fd20567618599d.svg";